import type { TranslationKey } from "../locales";
import type { Region } from "./regions";

export function getRegionTranslationKey(region: Region): TranslationKey {
	return `misc.regions.${region.toLowerCase() as Lowercase<Region>}` as const;
}
